export const UserRole = {
    ORGANIZATION_OWNER: 1,
    ORGANIZATION_MANAGER: 2,
    ORGANIZATION_USER: 3,
    PROJECT_MANAGER: 100,
    USER: 101,
    VIEWER: 102,
}